import React, { useState, useEffect, useContext } from "react";
import { withOktaAuth } from "@okta/okta-react";
import TopNavigation from "./TopNavigation";
import { Avatar } from "@jll/avatar";
import { Typography, MenuItem } from "@material-ui/core";
import Select from "@jll/select";
import { withStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
import { styles } from "./styles";
import BrandColors from "../../styles/BrandColors";
import { recordTypes } from "../../API/config";
import ModalDialogContext from "../../Context/ModalDialog/ModalDialogContext";
import Icon from "@jll/icon";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { getLanguages } from "../../API/Country";
import ViewUserAccess from "../../Container/Admin/Component/AccessControlRules/Components/ViewUserAccess";

require("dotenv").config();

const { REACT_APP_ALLOW_LANGUAGE_SELECTION } = process.env || {};
const languageSelctionAllowed =
  parseInt(REACT_APP_ALLOW_LANGUAGE_SELECTION, 10) === 1 || false;

const { JLLBrandColors } = BrandColors;
const { Red } = JLLBrandColors;

const AppBar = (props) => {
  const { classes, user, hasPermission, hasAnyRecordPermission, logout } =
    props;
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [languageOptions, setLanguageOptions] = useState([]);
  const [canViewAccess, setCanViewAccess] = useState();
  const [isViewUserAccess, setIsViewUserAccess] = useState(false);

  useEffect(() => {
    const evalPermissions = async () => {
      const hasRecordPermission = await hasPermission(
        recordTypes.record.name,
        recordTypes.record.actions.search.name
      );
      const hasCheckdPermission = await hasPermission(
        recordTypes.checkRequest.name,
        recordTypes.checkRequest.actions.search.name
      );

      const adminRecordTypes = Object.keys(recordTypes).filter(
        (rt) => recordTypes[rt].isAdmin
      );

      const hasAdminPermission = await hasAnyRecordPermission(adminRecordTypes);
      sethasRecordPermission(hasRecordPermission);
      sethasCheckdPermission(hasCheckdPermission);
      sethasAdminPermission(hasAdminPermission);

      const canViewAccess = await hasPermission(
        recordTypes.accessRule.name,
        recordTypes.accessRule.actions.viewSelf.name
      );
      setCanViewAccess(canViewAccess);
    };

    const fetchLngDetails = async () => {
      const result = await getLanguages();
      const { data = [] } = result;
      const languageOptions = data
        .filter((l) => l.isAvailable)
        .map((lang) => ({
          value: lang.iso_code_2,
          label: lang.localName,
        }));
      setLanguageOptions(languageOptions);
      let selectedLanguage = languageOptions.find(
        (lng) =>
          lng.value === i18next.language ||
          `${lng.value}-${user.locale}` === i18next.language
      );
      if (!selectedLanguage) {
        selectedLanguage = languageOptions.find(
          (lng) =>
            lng.value === "en" || `en-${user.locale}` === i18next.language
        );
      }
      setSelectedLanguage(selectedLanguage);
    };

    evalPermissions();
    if (languageSelctionAllowed) {
      fetchLngDetails();
    }
  }, []);

  useEffect(() => {
    let selectedLanguage = languageOptions.find(
      (lng) =>
        lng.value === i18next.language ||
        `${lng.value}-${user.locale}` === i18next.language
    );
    if (!selectedLanguage) {
      selectedLanguage = languageOptions.find(
        (lng) => lng.value === "en" || `en-${user.locale}` === i18next.language
      );
    }
    setSelectedLanguage(selectedLanguage);
  }, [i18next.language]);

  const [hasRecordPermission, sethasRecordPermission] = useState();
  const [hasCheckdPermission, sethasCheckdPermission] = useState();
  const [hasAdminPermission, sethasAdminPermission] = useState();

  const { showConfirmation } = useContext(ModalDialogContext);

  const getNavLink = (link, label) => {
    return (
      <NavLink
        className={classes.topbarLink}
        to={link}
        activeStyle={{ color: Red.core, fontWeight: 600 }}
      >
        {label}
      </NavLink>
    );
  };

  const showAccessDetails = () => {
    setIsViewUserAccess(true);
  };

  const closeAccessDetails = () => {
    setIsViewUserAccess(false);
  };

  const getAvatar = () => {
    const menuItems = [
      <MenuItem
        key="logout"
        onClick={() => {
          showConfirmation({
            message: t("messages.logout.confirm"),
            onPressYes: async (event) => {
              logout();
            },
          });
        }}
      >
        {t("labels.header.menu.logout")}
      </MenuItem>,
    ];
    if (canViewAccess) {
      menuItems.push(
        <MenuItem
          key="viewAccess"
          onClick={() => {
            showAccessDetails();
          }}
        >
          {t("labels.header.menu.viewMyAccess")}
        </MenuItem>
      );
    }
    return (
      <Avatar
        name={user ? `${user.name}` : ""}
        size="medium"
        menuItems={menuItems}
        menuAlign="center"
      />
    );
  };

  const rightItems = [];
  if (languageSelctionAllowed) {
    rightItems.push(
      <div className={classes.langGroup}>
        <Icon className="fal fa-2x fa-globe" style={{ color: "white" }} />
        <Select
          value={selectedLanguage}
          className={classes.langSelector}
          onChange={(slLang) => {
            i18next.changeLanguage(`${slLang.value}-${user.locale}`);
          }}
          isSearchable={false}
          isMulti={false}
          options={languageOptions}
        />
      </div>
    );
  }
  if (hasRecordPermission) {
    rightItems.push(getNavLink("/records", t("labels.header.menu.records")));
  }
  if (hasCheckdPermission) {
    rightItems.push(getNavLink("/checks", t("labels.header.menu.checks")));
  }
  if (hasAdminPermission) {
    rightItems.push(getNavLink("/admin", t("labels.header.menu.admin")));
  }
  rightItems.push(getAvatar());

  return (
    <div className={classes.root}>
      <div className={classes.productName}>
        <Typography
          component="h3"
          style={{ fontSize: 16, fontWeight: 300, margin: "1em" }}
        >
          {t("labels.header.title")}
        </Typography>
      </div>
      <TopNavigation
        className={classes.noShadow}
        containerElement="header"
        logoType="white"
        style={{ zIndex: 30, fontSize: 16 }}
        rightItems={rightItems}
        theme="dark"
        fixed
      />
      {canViewAccess && isViewUserAccess && (
        <ViewUserAccess
          open={isViewUserAccess}
          onclose={closeAccessDetails}
          userEmail={user.email}
        />
      )}
    </div>
  );
};

export default withOktaAuth(withStyles(styles)(AppBar));
